const BAND_IMAGE =
  "https://images.unsplash.com/photo-1520583457224-aee11bad5112?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZ2xvd2luZyUyMG5vZGVzJTIwZGF0YSUyMG5ldHdvcmslMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNjZ8MA&ixlib=rb-4.1.0&q=85";

export const Band = () => {
  return (
    <section
      data-testid="philosophy-band"
      className="border-b border-seam relative overflow-hidden bg-coal"
    >
      <img
        src={BAND_IMAGE}
        alt="Deep dark ember workspace"
        className="flint-drift absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ground via-ground/80 to-ground" />
      <div className="w-full py-20 px-6 relative">
        <div className="max-w-3xl mx-auto text-center relative z-10">
          <span className="text-xs uppercase tracking-widest text-ember font-semibold">
            Developer Philosophy
          </span>
          <h2 className="font-serif text-3xl sm:text-5xl text-white my-4">
            Ship more. Burn less.
          </h2>
          <p className="text-base text-smoke max-w-xl mx-auto mb-8">
            AI agents generate massive context overhead. Flintly keeps your
            code lean and your API spend sustainable.
          </p>
          <a
            href="#waitlist"
            data-testid="band-early-access-link"
            className="inline-block bg-ember hover:bg-ember-deep text-black font-semibold rounded-lg px-8 py-3.5 text-sm transition-colors"
          >
            Get Early Access
          </a>
        </div>
      </div>
    </section>
  );
};
